module.exports = __webpack_public_path__ + "media/images/powerpoint/edf-background-ef59358d76cac3cc677544829daa494b.png";